import React from 'react';
import { Grid, Header, Button, Icon } from 'semantic-ui-react';

const PaymentFailurePage = (props) => {
	return (
		<Grid centered>
			<Grid.Column>
				<Header
					as="h1"
					textAlign="center"
				>
					<Icon.Group size="large">
						<Icon
							name="circle outline"
							color="red"
						/>
						<Icon
							name="warning"
							color="red"
							size="tiny"
						/>
					</Icon.Group>
						Payment Failure
				</Header>
				<center>
					<p>Processing your Payment was not successful.</p>
					<Button
						primary
						type="sumbit"
						onClick={
							() => props.history.push('/tickets')
						}
					>
							BACK TO HOME
					</Button>
				</center>
			</Grid.Column>
		</Grid>
	);
};

export default PaymentFailurePage;
